function getAccountId() {
    const user = JSON.parse(sessionStorage.getItem("user"));
    return user?.id;
}

angular.module('bizmetryApp').controller('LinkDatasourceDialogController', function (
    $scope, $mdDialog, $mdToast, DatasourceService, resource, template
) {
    const accountId = getAccountId();

    if (!accountId) {
        console.error("❌ Account ID not found in sessionStorage.");
        $mdDialog.cancel();
        return;
    }

    // ============================================
    // Inicialización
    // ============================================
    $scope.resource = resource;
    $scope.resourceName = resource.name;

    $scope.datasources = [];
    $scope.schemas = [];
    $scope.entities = [];
    $scope.template = template

    $scope.selectedDatasourceId = null;
    $scope.selectedDatasource = null;
    $scope.selectedSchema = null;
    $scope.selectedEntity = null;
    $scope.selectedEntityId = null;

    $scope.entitySearchText = '';

    console.log('🔗 Link Datasource Dialog opened for resource:', resource.name);

    // ============================================
    // Check if there are online datasources
    // ============================================
    $scope.hasOnlineDatasources = function () {
        return $scope.datasources && $scope.datasources.length > 0;
    };

    // ============================================
    // Cancel
    // ============================================
    $scope.cancel = function () {
        $mdDialog.cancel();
    };

    // ============================================
    // On Datasource Change
    // ============================================
    $scope.onDatasourceChange = function () {
        const selectedId = $scope.selectedDatasourceId;
        console.log('📦 Datasource changed:', selectedId);

        $scope.selectedDatasource = $scope.datasources.find(ds => ds.id === selectedId);

        if (!$scope.selectedDatasource) {
            console.warn("⚠️ Datasource not found");
            return;
        }

        // Reset downstream selections
        $scope.schemas = [];
        $scope.entities = [];
        $scope.selectedSchema = null;
        $scope.selectedEntity = null;
        $scope.selectedEntityId = null;

        // Load schemas for selected datasource
        DatasourceService.getSchemas(selectedId)
            .then(data => {
                $scope.schemas = data;
                console.log('✅ Schemas loaded:', $scope.schemas.length);

                if ($scope.schemas.length === 0) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('No schemas found in this datasource')
                            .position('top right')
                            .hideDelay(3000)
                    );
                }
            })
            .catch(err => {
                console.error('❌ Error loading schemas:', err);
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Error loading schemas')
                        .position('top right')
                        .hideDelay(3000)
                );
            });
    };

    // ============================================
    // ✅ FIX: Watch Schema Change (como en import)
    // ============================================
    $scope.$watch('selectedSchema', function (newSchema) {
        if (newSchema) {
            console.log("🟢 Schema changed → loading entities");
            $scope.onSchemaChange();
        }
    });

    // ============================================
    // ✅ FIX: On Schema Change (mejorado)
    // ============================================
    $scope.onSchemaChange = function () {
        console.log('📁 Schema changed:', $scope.selectedSchema);

        // Reset downstream selections
        $scope.entities = [];
        $scope.selectedEntity = null;
        $scope.selectedEntityId = null;

        if (!$scope.selectedDatasourceId || !$scope.selectedSchema) {
            console.warn("⚠️ Schema or datasource missing");
            return;
        }

        console.log('🔍 Loading entities for schema:', $scope.selectedSchema);

        // Load entities (tables) for selected schema
        DatasourceService.getEntities($scope.selectedDatasourceId, $scope.selectedSchema)
            .then(data => {
                console.log('📊 Raw entities data received:', data);

                if (!Array.isArray(data)) {
                    console.error("❌ Unexpected response format for entities:", data);
                    return;
                }

                // ✅ Process entities (similar a import)
                $scope.entities = data.map(entity => {
                    // TODO: Check if this table is already linked to another resource
                    const isAlreadyLinked = false; // Implement logic here

                    return {
                        tableName: entity.tableName,
                        tableSchema: entity.tableSchema,
                        tableType: entity.tableType,
                        remarks: entity.remarks,
                        disabled: isAlreadyLinked,
                        showTooltip: false,
                        attributes: null,
                        loadingAttributes: false
                    };
                });

                console.log('✅ Entities processed:', $scope.entities.length);

                // ✅ Force Angular to detect changes
                $scope.$applyAsync();

                if ($scope.entities.length === 0) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('No tables found in this schema')
                            .position('top right')
                            .hideDelay(3000)
                    );
                }
            })
            .catch(err => {
                console.error('❌ Error loading entities:', err);
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Error loading tables')
                        .position('top right')
                        .hideDelay(3000)
                );
            });
    };

    // ============================================
    // Select Entity (Single Selection with Radio Button)
    // ============================================
    $scope.selectEntity = function (entity) {
        if (entity.disabled) {
            console.warn('⚠️ Entity is disabled:', entity.tableName);
            return;
        }

        $scope.selectedEntity = entity;
        $scope.selectedEntityId = entity.tableName;

        console.log('✅ Entity selected:', entity.tableName);

        // Load attributes if not already loaded
        if (!entity.attributes && !entity.loadingAttributes) {
            $scope.loadAttributes(entity);
        }
    };

    // ============================================
    // Load Attributes for Entity
    // ============================================
    $scope.loadAttributes = function (entity) {
        if (entity.attributes || entity.loadingAttributes) {
            return;
        }

        entity.loadingAttributes = true;

        console.log('🔍 Loading attributes for:', entity.tableName);

        DatasourceService.getAttributes($scope.selectedDatasourceId, $scope.selectedSchema, entity.tableName)
            .then(data => {
                entity.attributes = data;
                entity.loadingAttributes = false;
                console.log('✅ Attributes loaded for', entity.tableName, ':', entity.attributes.length);
            })
            .catch(err => {
                console.error(`❌ Error loading attributes for ${entity.tableName}:`, err);
                entity.attributes = [];
                entity.loadingAttributes = false;
            });
    };

    // ============================================
    // Toggle Tooltip con posicionamiento inteligente
    // ============================================
    $scope.toggleTooltip = function ($event, entity) {
        $event.stopPropagation();
        $event.preventDefault();

        console.log("🔵 toggleTooltip called for:", entity.tableName, "current state:", entity.showTooltip);

        // Close all other tooltips
        $scope.entities.forEach(e => {
            if (e !== entity) {
                e.showTooltip = false;
            }
        });

        entity.showTooltip = !entity.showTooltip;

        console.log("🟢 New tooltip state:", entity.showTooltip);

        if (!entity.showTooltip) return;

        // Calculate tooltip position
        const trigger = $event.currentTarget;
        const triggerRect = trigger.getBoundingClientRect();
        const dialog = document.querySelector('.link-datasource-dialog');
        const dialogRect = dialog.getBoundingClientRect();

        const offsetTop = triggerRect.bottom - dialogRect.top + 6;
        const offsetLeft = triggerRect.left - dialogRect.left;
        const tooltipMaxHeight = 300;
        const dialogHeight = dialogRect.height;

        let top = offsetTop;
        if (dialogHeight - offsetTop < tooltipMaxHeight + 20) {
            top = triggerRect.top - dialogRect.top - tooltipMaxHeight - 6;
        }

        let left = offsetLeft;
        const maxLeft = dialogRect.width - 380;
        if (left > maxLeft) left = maxLeft;
        if (left < 0) left = 10;

        entity.tooltipPosition = {
            position: 'absolute',
            top: `${top}px`,
            left: `${left}px`,
            'z-index': 1000,
            'max-height': `${tooltipMaxHeight}px`,
            'overflow-y': 'auto'
        };

        // Load attributes if not loaded
        if (!entity.attributes && !entity.loadingAttributes) {
            $scope.loadAttributes(entity);
        }
    };

    // ============================================
    // Close All Tooltips
    // ============================================
    $scope.closeAllTooltips = function () {
        $scope.entities.forEach(e => e.showTooltip = false);
    };

    // ============================================
    // Document Click Handler (cerrar tooltips al hacer click fuera)
    // ============================================
    const documentClickHandler = function (event) {
        if (event.target.closest('.modern-tooltip') ||
            event.target.closest('.md-icon-button[aria-label="View details"]')) {
            console.log("🔵 Click dentro de tooltip o botón info - ignorando");
            return;
        }

        console.log("🔴 Click fuera - cerrando tooltips");
        $scope.$apply(() => {
            $scope.closeAllTooltips();
        });
    };

    document.addEventListener('click', documentClickHandler);

    // Cleanup on destroy
    $scope.$on('$destroy', function () {
        document.removeEventListener('click', documentClickHandler);
    });

    // ============================================
    // Confirm Link - Opens Column Mapping Dialog
    // ============================================
    // ============================================
    // Confirm Link - Opens Column Mapping Dialog
    // ============================================
    $scope.confirmLink = function () {
        if (!$scope.selectedEntity) {
            $mdToast.show(
                $mdToast.simple()
                    .textContent('Please select a table to link')
                    .position('top right')
                    .hideDelay(2000)
            );
            return;
        }

        console.log('🔗 Opening column mapping dialog');
        console.log('  Resource:', $scope.resource);
        console.log('  Datasource:', $scope.selectedDatasource);
        console.log('  Schema:', $scope.selectedSchema);
        console.log('  Table:', $scope.selectedEntity.tableName);
        console.log('  Template: ', $scope.template);

        // Abrir diálogo de mapeo de columnas (SIN cerrar el actual todavía)
        $mdDialog.show({
            controller: 'TableMapperDialogController',
            templateUrl: '/template/tableMapper/table-mapper-dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            escapeToClose: false,
            fullscreen: false,
            multiple: true,  // ← Permite abrir sobre el dialog actual
            locals: {
                templateId: $scope.template.id,
                resourceTypeId: $scope.resource.id,
                datasourceId: $scope.selectedDatasource.id,
                datasourceName: $scope.selectedDatasource.datasourceName,
                schema: $scope.selectedSchema,
                tableName: $scope.selectedEntity.tableName,
                resource: resource,
                templateInstance: angular.copy(template),
                mode: 'create'
            }
     
        }).then(function (result) {
            // Verificar que haya resultado
            if (!result) {
                console.log('❌ Table mapper cancelled or no changes');
                // Cerrar sin cambios
                $mdDialog.cancel();
                return;
            }

            console.log('✅ Table mapper result:', result);

            // Aplicar los cambios al template
            applyTableMapperChanges(result);

            // Mostrar mensaje de éxito
            const totalChanges =
                (result.mappings?.length || 0) +
                (result.modifiedAttributes?.length || 0) +
                (result.createdAttributes?.length || 0);

            $mdToast.show(
                $mdToast.simple()
                    .textContent(`Successfully applied ${totalChanges} change${totalChanges !== 1 ? 's' : ''} to template`)
                    .position('top right')
                    .hideDelay(3000)
            );

            // ✅ AHORA SÍ cerrar el dialog devolviendo el template actualizado
            $mdDialog.hide({
                template: $scope.template,
                resource: $scope.resource,
                changes: result
            });

        }).catch(function (error) {
            // Usuario canceló el mapeo o hubo error
            console.log('❌ Column mapping cancelled or error:', error);
            $mdDialog.cancel();
        });
    };

    // ============================================
    // Apply Table Mapper Changes to Template
    // ============================================
    function applyTableMapperChanges(result) {
        const { mappings, modifiedAttributes, createdAttributes } = result;

        console.log('📝 Applying table mapper changes to template...');
        console.log('  Template ID:', $scope.template.id);
        console.log('  Resource Type ID:', $scope.resource.id);

        // Buscar el resource type dentro del template
        const resourceType = $scope.template.templateConfig.resource_types.find(
            rt => rt.id === $scope.resource.id
        );

        if (!resourceType) {
            console.error('❌ Resource type not found in template!');
            return;
        }

        // Asegurarnos de que attribute_types existe en el template config
        if (!$scope.template.templateConfig.attribute_types) {
            $scope.template.templateConfig.attribute_types = [];
        }

        // Asegurarnos de que env_mappings existe en el resource type
        if (!resourceType.env_mappings) {
            resourceType.env_mappings = [];
        }

        // Obtener atributos del resource actual (filtrados por resource_id)
        const resourceAttributes = $scope.template.templateConfig.attribute_types.filter(
            attr => attr.resource_id === $scope.resource.id
        );

        console.log(`📋 Current attributes for this resource: ${resourceAttributes.length}`);

        // 1️⃣ ATRIBUTOS MODIFICADOS - Actualizar tipos
        if (modifiedAttributes && modifiedAttributes.length > 0) {
            console.log(`🔄 Updating ${modifiedAttributes.length} modified attributes...`);

            modifiedAttributes.forEach(modAttr => {
                const attribute = $scope.template.templateConfig.attribute_types.find(
                    attr => attr.id === modAttr.id
                );

                if (attribute) {
                    console.log(`  ✏️  ${modAttr.name}: ${modAttr.originalType} → ${modAttr.newType}`);
                    attribute.scalar_attribute_type = modAttr.newType;
                } else {
                    console.warn(`  ⚠️  Attribute not found: ${modAttr.id} (${modAttr.name})`);
                }
            });
        }

        // 2️⃣ ATRIBUTOS CREADOS - Agregar nuevos atributos
        if (createdAttributes && createdAttributes.length > 0) {
            console.log(`➕ Creating ${createdAttributes.length} new attributes...`);

            createdAttributes.forEach(newAttr => {
                const attributeType = {
                    id: newAttr.id,
                    name: newAttr.name,
                    enabled: true,
                    description: 'Imported from table column',
                    resource_id: $scope.resource.id,  // ← Relacionar con el resource
                    scalar_attribute_type: newAttr.dataType,
                    isPrimaryKey: newAttr.isPrimaryKey || false,
                    isSensitive: false,
                    isResourceNameField: false,
                    isResourceDescriptionField: false
                };

                console.log(`  ➕ ${newAttr.name} (${newAttr.dataType})${newAttr.isPrimaryKey ? ' [PK]' : ''}`);
                $scope.template.templateConfig.attribute_types.push(attributeType);
            });
        }

        // 3️⃣ MAPPINGS - Setear column_metadata_name
        if (mappings && mappings.length > 0) {
            console.log(`🔗 Applying ${mappings.length} column mappings...`);

            mappings.forEach(mapping => {
                const attribute = $scope.template.templateConfig.attribute_types.find(
                    attr => attr.id === mapping.attributeId
                );

                if (attribute) {
                    console.log(`  🔗 ${mapping.attributeName} → ${mapping.columnName}`);
                    attribute.column_metadata_name = mapping.columnName;
                } else {
                    console.warn(`  ⚠️  Attribute not found for mapping: ${mapping.attributeId} (${mapping.attributeName})`);
                }
            });
        }

        // 4️⃣ ENVIRONMENT MAPPING - Crear y agregar mapping de environment/datasource/tabla
        console.log('🌍 Creating environment mapping...');

        // Verificar si ya existe un mapping para este environment
        const existingMappingIndex = resourceType.env_mappings.findIndex(
            em => em.env_id === $scope.selectedDatasource.environmentId
        );

        const environmentMapping = {
            env_id: $scope.selectedDatasource.environmentId,
            env_name: $scope.selectedDatasource.environmentName,
            datasource_id: $scope.selectedDatasource.id,
            datasource_name: $scope.selectedDatasource.datasourceName,
            is_master: true,
            schema_name: $scope.selectedSchema,
            table_name: $scope.selectedEntity.tableName
        };

        if (existingMappingIndex >= 0) {
            // Actualizar mapping existente
            console.log(`  🔄 Updating existing mapping for environment: ${environmentMapping.env_name}`);
            resourceType.env_mappings[existingMappingIndex] = environmentMapping;
        } else {
            // Agregar nuevo mapping
            console.log(`  ➕ Adding new mapping for environment: ${environmentMapping.env_name}`);
            resourceType.env_mappings.push(environmentMapping);
        }

        console.log(`  🌍 Environment: ${environmentMapping.env_name}`);
        console.log(`  💾 Datasource: ${environmentMapping.datasource_name}`);
        console.log(`  📊 Schema: ${environmentMapping.schema_name}`);
        console.log(`  📋 Table: ${environmentMapping.table_name}`);

        // 5️⃣ MARCAR COMO IMPORTED
        if (!resourceType.is_resource_imported) {
            console.log('  ✅ Marking resource as imported');
            resourceType.is_resource_imported = true;
        }

        // Log final
        const totalResourceAttributes = $scope.template.templateConfig.attribute_types.filter(
            attr => attr.resource_id === $scope.resource.id
        ).length;

        console.log(`✅ All changes applied!`);
        console.log(`  📋 Total attributes for this resource: ${totalResourceAttributes}`);
        console.log(`  🌍 Total environment mappings: ${resourceType.env_mappings.length}`);
        console.log('📄 Updated template config:', $scope.template.templateConfig);

        // Forzar actualización del scope si es necesario
        if (!$scope.$$phase) {
            $scope.$apply();
        }
    }
    // ============================================
    // ✅ Cargar Datasources al inicio (SOLO ONLINE)
    // ============================================
    DatasourceService.getDatasources(accountId)
        .then(data => {
            // ✅ FILTRAR SOLO DATASOURCES ONLINE y normalizar environment info
            $scope.datasources = data
                .filter(ds => ds.isOnline)
                .map(ds => {
                    // ✅ DEBUG: Ver qué campos trae el datasource
                    console.log('📦 Datasource:', ds.datasourceName, {
                        environmentTypeId: ds.environmentTypeId,
                        environmentTypeName: ds.environmentTypeName
                    });

                    // ✅ Normalizar para uso interno consistente
                    return {
                        ...ds,
                        environmentId: ds.environmentTypeId,      // ← Mapear para consistencia
                        environmentName: ds.environmentTypeName   // ← Mapear para consistencia
                    };
                });

            console.log('✅ Online datasources loaded:', $scope.datasources.length);

            if ($scope.datasources.length === 0) {
                console.warn('⚠️ No online datasources available');
                return;
            }

            // ✅ Auto-select first online datasource
            $scope.selectedDatasourceId = $scope.datasources[0].id;
            $scope.onDatasourceChange();
        })
        .catch(err => {
            console.error('❌ Error loading datasources:', err);
            $mdToast.show(
                $mdToast.simple()
                    .textContent('Error loading datasources')
                    .position('top right')
                    .hideDelay(3000)
            );
        });


    // ============================================
    // ✅ FIX: Watch selectedEntityId para sincronizar con selectedEntity
    // ============================================
    $scope.$watch('selectedEntityId', function (newVal) {
        if (newVal) {
            var entity = $scope.entities.find(function (e) {
                return e.tableName === newVal;
            });
            if (entity && entity !== $scope.selectedEntity) {
                $scope.selectedEntity = entity;
                console.log('✅ Entity synchronized via watch:', entity.tableName);

                // Load attributes if not already loaded
                if (!entity.attributes && !entity.loadingAttributes) {
                    $scope.loadAttributes(entity);
                }
            }
        }
    });
});